import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PAlertComponent } from './p-alert.component';
import { PSnackbarComponent } from './p-snackbar.component';
import { PIconModule } from '@panaya/ui/p-icon';
import { PButtonModule } from '@panaya/ui/p-button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [PAlertComponent, PSnackbarComponent],
    imports: [CommonModule, RouterModule, PIconModule, PButtonModule, MatSnackBarModule, TranslateModule],
    exports: [PAlertComponent, PSnackbarComponent]
})
export class PSnackbarModule {}
